export default {"src":"/_next/static/media/user.55eef9bf.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};